import {useEffect, useState} from "react";

import Icon from "../Icon/Icon";
import Checkbox from "../FormComponents/Checkbox/Checkbox";
import Button from "../Button/Button";

import {InfiosFilterItem} from "./Filter.style";

export default function FilterItem(props) {
    const {
        typeName,
        title,
        items,
        checkedItems,
        isOpen,
        onOpen,
        onClose,
        onApply,
        boxAlignment,
        tagCount,
        pageLanguage,
        applyFilterText,
        closeText,
        hoverTextColor,
        textColor,
        hoverBackgroundColor,
        backgroundColor
    } = props;

    const [selectedTag, setSelectedTag] = useState([]);
    const [selectedNewTag, setSelectedNewTag] = useState([]);
    const [hasCheckedItems, setHasCheckedItems] = useState(false);
    const [hasChanged, setHasChanged] = useState(false);

    useEffect(() => {
        if (checkedItems) {
            setSelectedTag(checkedItems);
            setHasCheckedItems(true);
        } else {
            setSelectedTag([]);
            setSelectedNewTag([]);
            setHasCheckedItems(false);
        }
    }, [checkedItems])

    function toggleOpen() {
        isOpen ? onClose() : onOpen();
    }

    function handleChange(item) {
        setHasChanged(true);
        if (selectedNewTag.includes(item.name)) {
            setSelectedNewTag(selectedNewTag.filter(selectedTagItem => selectedTagItem !== item.name));
        } else {
            setSelectedNewTag([...selectedNewTag, item.name]);
        }
    }

    function handleApply() {
        setHasChanged(false);
        if (selectedNewTag == '') {
            clearAndSubmit();
            onClose();
            return;
        }
        const newArray = Array.from(new Set(selectedNewTag));
        onApply(typeName, newArray);
        toggleOpen();
    }

    function handleApplyEmpty() {
        toggleOpen();
    }

    function getName(tag) {
        const item = items.find(item => item.name === tag);
        return item ? item['jcr:title'] : null;
    }

    function clearAndSubmit() {
        setSelectedTag([]);
        onApply(typeName, []);

    }

    function isChecked(item) {
        if (items.length === 1) return true;
        return selectedNewTag.includes(item.name) && tagCount[item.name] > 0;
    }

    return (
        <InfiosFilterItem open={isOpen} hasChecked={selectedTag.length} hasOneItem={items.length === 1} hoverTextColor={hoverTextColor} textColor={textColor} hoverBackgroundColor={hoverBackgroundColor} backgroundColor={backgroundColor}>
            <button onClick={toggleOpen} className="filter__button">
                <p className="infios__filter__type">{title}{selectedTag.length ? `: ${getName(selectedTag[0])} ` : ''}&nbsp;
                    <strong>{selectedTag.length > 1 ? `+${selectedTag.length - 1}` : ''}</strong></p>
            </button>
            <div className="filter__icon">
                {hasCheckedItems ? (
                    <Icon icon="close-round" className="close__round" onClick={clearAndSubmit}/>
                ) : (
                    <Icon icon="arrow-forward"/>
                )}
            </div>
            <div className={`filter__box ${isOpen && 'active'} ${boxAlignment}`}>
                <button onClick={() => {
                    if (hasChanged) {
                        setSelectedNewTag([...selectedTag]);
                        onClose();
                        return;
                    }
                    handleApplyEmpty();
                }}>
                    <Icon icon="close"/>
                </button>

                <div className="inner__box inner__box-full">
                    <h6 className="filter__box_title">{title}</h6>
                    {items.map((item, i) => (
                        <div className="filter__box_item" key={i}>
                            <Checkbox name={item.name} checked={isChecked(item)}
                                      labelText={item['jcr:title.' + pageLanguage] ?? item['jcr:title']}
                                      disabled={tagCount[item.name] === 0 || items.length === 1}
                                      onClick={(e) => handleChange(item)}/>
                            <span className="filter__box_item-amount">{tagCount[item.name]}</span>
                        </div>
                    ))}
                </div>
                <div className="inner__box">
                    {hasChanged ? (
                        <Button text={applyFilterText} noIcon blue onClick={handleApply}/>
                    ) : (
                        <Button text={closeText} noIcon white onClick={handleApplyEmpty}/>
                    )}
                </div>
            </div>
        </InfiosFilterItem>
    );
}
